<div class="tooth-editor-wrapper" [class.partially-read-only]="isReadOnly$ | async">
  <rx-unit-type *ngIf="(isReadOnly$ | async) === false" [toothClicked]="unitTypeMenuInput$ | async" (unitTypeSelected)="handleUnitTypeSelection($event)"
    (unitTypeInBridgeSelected)="handleUnitTypeInBridgeSelection($event)"></rx-unit-type>
  <div class="tooth-editor">
    <rx-tooth-editor-header [isReadOnly]="isReadOnly$ | async" [isBridge]="isBridge$ | async" [unitTypeName]="unitTypeName$ | async"
      (modalClosed)="handleModalClose($event)">
    </rx-tooth-editor-header>
    <rx-banner *ngIf="isReadOnlyBannerVisible() | async" [type]="'info'" [message]="'ReadOnlyMode.ReadOnlyMessage' | translate"></rx-banner>
    <rx-mini-teeth-diagram [isReadOnly]="isReadOnly$ | async" [teeth]="teeth$ | async" [toothClickedOn]="toothClickedOn$ | async"
      [teethNumberingSystem]="teethNumberingSystem$ | async" (toothClicked)="handleToothClick($event)" [shouldHideDetails]="shouldHideDetails">
    </rx-mini-teeth-diagram>
  </div>
  <tlk-modal-content class="tooth-editor-body">
    <rx-crown-section *ngIf="!((isImplantBased$ | async) || (isImplantPosition$ | async))"
      [toothClickedOn]="toothClickedOn$ | async" [isReadOnly]="isReadOnly$ | async"></rx-crown-section>
    <rx-implant-position *ngIf="isImplantPosition$ | async"
      [implantTypeId]="(toothClickedOn$ | async)?.ImplantTypeID"
      [implantsViewData]="(toothClickedOn$ | async)?.ImplantsViewData"
      (implantTypeIdChange)="handleImplantTypeIdChange($event)"
      [isReadOnly]="isReadOnly$ | async"></rx-implant-position>

    <div *ngIf="isImplantBased$ | async" id="tooth-editor-body-container">
      <ng-container *ngIf="procedureMap.TypeId !== TypeEnum.Full_Denture_implant_based; else fullDentureImplantBased">
        <rx-banner [type]="'notification'" *ngIf="showImplantAbutmentDisclaimerBanner$ | async" [message]="'ToothEditor.Implant Abutment Disclaimer' | translate"></rx-banner>

      <ng-container *ngIf="shouldShowNewImplantsView$ | async">
        <ng-container *ngIf="implantsViewAppParameters$ | async as appParameters">
          <rx-banner
            *ngIf="showOfflineBanner$ | async"
            class="tooth-editor-offline-banner"
            type="notification"
            [showOfflineIcon]="true"
            [title]="'IteroImplants.ImplantsOfflineModeHeader' | translate"
            [message]="'IteroImplants.ImplantsOfflineModeMessage' | translate"
          ></rx-banner>
          <div class="implants-view-container">
            <rx-implants-view [appParameters]="appParameters"></rx-implants-view>
          </div>
        </ng-container>
      </ng-container>
        <div *ngIf="(shouldShowNewImplantsView$ | async) === false">
        <rx-manufacture-section [toothClickedOn]="toothClickedOn$ | async"
              class="manufacture-section"
              [isReadOnly]="isReadOnly$ | async">
        </rx-manufacture-section>
        </div>
        <mat-accordion [multi]="true">

          <mat-expansion-panel *ngIf="(isImplantBased$ | async)"
            togglePosition="before"
            id="restoration-type-expansion-panel"
          >
            <mat-expansion-panel-header class="rx-expansion-header">
              <mat-panel-title id="restoration-type-panel-title">
                {{ 'ToothEditor.RestorationType' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <rx-restoration-type-section
              [ImplantBasedRestorationTypeId]="(toothClickedOn$ | async)?.ImplantBasedRestorationTypeId"
              [AbutmentType]="(toothClickedOn$ | async)?.AbutmentType"
              [AbutmentMaterialId]="(toothClickedOn$ | async)?.AbutmentMaterialId"
              [isReadOnly]="isReadOnly$ | async"
              (restorationTypeChanged)="onRestorationTypeChanged($event)"
            ></rx-restoration-type-section>
          </mat-expansion-panel>

          <mat-expansion-panel id="crown-expansion-panel" togglePosition="before" >
            <mat-expansion-panel-header class="rx-expansion-header">
              <mat-panel-title id="crown-expansion-panel-title">
                {{ 'ToothEditor.Crown' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <rx-crown-section [toothClickedOn]="toothClickedOn$ | async"  [isReadOnly]="isReadOnly$ | async"></rx-crown-section>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>

      <ng-template #fullDentureImplantBased>
        <rx-manufacture-section [toothClickedOn]="toothClickedOn$ | async"
              class="manufacture-section"
              [isReadOnly]="isReadOnly$ | async">
            </rx-manufacture-section>
      </ng-template>
    </div>
  </tlk-modal-content>
  <rx-tooth-editor-footer *ngIf="(isReadOnly$ | async) === false" (modalClosed)="handleModalClose($event)"></rx-tooth-editor-footer>
</div>
